module.exports = __webpack_public_path__ + "img/d9.a5e7b79c.jpg";